import { useConfigStore } from '../../Stores/Config';
import { useFormStore } from '../../Stores/Form';
import { activateOnKey } from "../../Helper/a11y";
import "./OneToFiveFormItem.scss";

function OneToFiveFormItem({ formItem }: { formItem: any }) {
    const configStore = useConfigStore();
    const formData = useFormStore(state => state.formData);
    const fieldFormData = formData[formItem.name];
    const setFormData = useFormStore(state => state.setFormData);
    const upToNumber = !isNaN(formItem.upToNumber) ? formItem.upToNumber : 5;
    const fromNumber = !isNaN(formItem.fromNumber) ? formItem.fromNumber : 0;
    const fields = Array.from({ length: upToNumber - (fromNumber - 1) }, (_, i) => fromNumber + i);

    const renderOption = (value: any) => {
        const isActive = fieldFormData && fieldFormData.value === value;
        const onItemClick = () => {
            setFormData(formItem.name, {
                value,
                dirty: true
            }, true);
        };
        return (
            <div
                className={`one-to-five-form-item-item ${isActive && "one-to-five-form-item-item--active"}`}
                key={value}
                role="radio"
                aria-checked={isActive}
                tabIndex={0}
                onClick={onItemClick}
                onKeyDown={activateOnKey(onItemClick)}>
                <span>{value}</span>
            </div>
        );
    };

    return (
        <div id={formItem.name} className="one-to-five-form-item" role="radiogroup" aria-required={formItem.required}>
            <div className="one-to-five-form-item-items">
                {fields.map((value: any) => renderOption(value))}
            </div>
            <div className="one-to-five-form-item-labels">
                <span>{fromNumber} - {formItem.lowestValueLabel}</span>
                <span>{upToNumber} - {formItem.highestValueLabel}</span>
            </div>
        </div>
    );
}

export default OneToFiveFormItem;
